import React from 'react';
import { FormInput } from 'styleguide/Inputs';
import RadiobuttonSelected from './assets/radiobutton-selected.svg';
import RadiobuttonEmpty from './assets/radiobutton-empty.svg';

export const StyledRadioButton = (props: {
  label?: string | JSX.Element;
  checked: boolean;
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
  style?: React.ComponentPropsWithRef<'label'>['style'];
}) => (
  <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', ...props.style }}>
    <FormInput
      type={'radiobutton'}
      checked={props.checked}
      onChange={props.onChange}
      style={{ display: 'none' }}
    />
    <div
      style={{
        display: 'inline',
        width: 24,
        height: 24,
        paddingInlineEnd: 8,
      }}
    >
      {props.checked ? <RadiobuttonSelected /> : <RadiobuttonEmpty />}
    </div>
    {props.label && <div style={{ display: 'inline', width: '100%' }}>{props.label}</div>}
  </label>
);
